import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import CircularProgress from "@mui/material/CircularProgress";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import CategoryIcon from "@mui/icons-material/Category";
import BookCategory from "./BookCategory";
import BookCollectionType from "./BookCollectionType";
import UserType from "./UserType";
import Author from "./Author";
import Publisher from "./Publisher";
import Vendor from "./Vendor";
import Rules from "./Rules";
import Book from "./Book";
import Issue from "./Issue";
import Return from "./Return";
import FineReport from "./FineReport";

function Library() {
  const [loading, setLoading] = useState(true);
  const [activeView, setActiveView] = useState("home");
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(false);
  }, []);

  const handleNavigate = (path) => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      navigate("/authentication/sign-in");
    } else {
      setActiveView(path);
    }
  };

  const handleBack = () => {
    setActiveView("home");
  };

  const renderContent = () => {
    switch (activeView) {
      case "bookcategory":
        return (
          <>
            <BookCategory />
          </>
        );
      case "bookcollectiontype":
        return (
          <>
            <BookCollectionType />
          </>
        );
      case "usertype":
        return (
          <>
            <UserType />
          </>
        );
      case "author":
        return (
          <>
            <Author />
          </>
        );
      case "publisher":
        return (
          <>
            <Publisher />
          </>
        );
      case "vendor":
        return (
          <>
            <Vendor />
          </>
        );
      case "rules":
        return (
          <>
            <Rules />
          </>
        );
      case "book":
        return (
          <>
            <Book />
          </>
        );
      case "issue":
        return (
          <>
            <Issue />
          </>
        );
      case "return":
        return (
          <>
            <Return />
          </>
        );
      case "finereport":
        return (
          <>
            <FineReport />
          </>
        );

      default:
        return (
          <Grid container spacing={3}>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<CategoryIcon />}
                onClick={() => handleNavigate("bookcategory")}
              >
                BOOK CATEGORY
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<CategoryIcon />}
                onClick={() => handleNavigate("bookcollectiontype")}
              >
                BOOK COLLECTION TYPE
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<CategoryIcon />}
                onClick={() => handleNavigate("usertype")}
              >
                USER TYPE
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<CategoryIcon />}
                onClick={() => handleNavigate("author")}
              >
                AUTHOR
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<CategoryIcon />}
                onClick={() => handleNavigate("publisher")}
              >
                PUBLISHER
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<CategoryIcon />}
                onClick={() => handleNavigate("vendor")}
              >
                VENDOR
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<CategoryIcon />}
                onClick={() => handleNavigate("rules")}
              >
                RULES
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<CategoryIcon />}
                onClick={() => handleNavigate("book")}
              >
                BOOKS
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<CategoryIcon />}
                onClick={() => handleNavigate("issue")}
              >
                ISSUE
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<CategoryIcon />}
                onClick={() => handleNavigate("return")}
              >
                RETURN
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<CategoryIcon />}
                onClick={() => handleNavigate("finereport")}
              >
                FINE REPORT
              </MDButton>
            </Grid>
          </Grid>
        );
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        {loading ? (
          <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
            <CircularProgress color="info" />
          </MDBox>
        ) : (
          <Card>
            <MDBox
              mx={2}
              mt={-1}
              py={1}
              px={2}
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <MDTypography variant="h6" color="white">
                LIBRARY MANAGEMENT SYSTEM
              </MDTypography>
              {activeView !== "home" && (
                <MDButton
                  variant="contained"
                  coloredShadow="info"
                  onClick={handleBack}
                  startIcon={<Icon>arrow_back</Icon>}
                  sx={{ mb: 0 }}
                >
                  Back to Library
                </MDButton>
              )}
            </MDBox>
            <MDBox p={1}>{renderContent()}</MDBox>
          </Card>
        )}
      </MDBox>
      <MDBox display="flex" flexDirection="column" minHeight="50vh">
        {/* This empty div is intentional for layout spacing */}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Library;
